import { render, staticRenderFns } from "./AdminDiscover.vue?vue&type=template&id=2a380da0&"
import script from "./AdminDiscover.vue?vue&type=script&lang=js&"
export * from "./AdminDiscover.vue?vue&type=script&lang=js&"
import style0 from "./AdminDiscover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports